"use client";

import BotbRAFProvider from "./provider";
import BotBRAFPageContent from "./page-content";
import DeviceProvider from "@/app/redux/features/device/DeviceProvider";
import React from "react";
import { ToastProvider } from "@/app/components/ToastNotification/toastProvider";

const BotbRAFPage = () => {
  return (
    <DeviceProvider>
      <BotbRAFProvider>
        <ToastProvider />
        <BotBRAFPageContent />
      </BotbRAFProvider>
    </DeviceProvider>
  );
};

export default BotbRAFPage;
